import { injectGlobal } from 'styled-components';
import styledNormalize from 'styled-normalize';
import ds from 'designsystem';

// adding fonts
import PoppinsRegularWoff from './fonts/poppins-v5-latin-ext-regular.woff';
import PoppinsRegularWoff2 from './fonts/poppins-v5-latin-ext-regular.woff2';
import PoppinsBoldWoff from './fonts/poppins-v5-latin-ext-700.woff';
import PoppinsBoldWoff2 from './fonts/poppins-v5-latin-ext-700.woff2';
import RobotoRegularWoff from './fonts/roboto-v18-latin-ext_latin-regular.woff';
import RobotoRegularWoff2 from './fonts/roboto-v18-latin-ext_latin-regular.woff2';
import RobotoLightWoff from './fonts/roboto-v18-latin-ext_latin-300.woff';
import RobotoLightWoff2 from './fonts/roboto-v18-latin-ext_latin-300.woff2';

/* Disable ESlint rules for this file */
/* eslint-disable */

injectGlobal`
${styledNormalize}

/* poppins-regular - latin-ext */
@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  src: url('${PoppinsRegularWoff2}') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('${PoppinsRegularWoff}') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
       local('Poppins Regular'), local('Poppins-Regular'),
}
/* poppins-700 - latin-ext */
@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  src: url('${PoppinsBoldWoff2}') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('${PoppinsBoldWoff}') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
       local('Poppins Bold'), local('Poppins-Bold'),
}
/* roboto-300 - latin-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 300;
  src: url('${RobotoLightWoff2}') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('${RobotoLightWoff}') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
       local('Roboto Light'), local('Roboto-Light'),
}
/* roboto-regular - latin-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  src: url('${RobotoRegularWoff2}') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
       url('${RobotoRegularWoff}') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
       local('Roboto'), local('Roboto-Regular'),
}

* {
  box-sizing: border-box;
}

.slick-slider .slick-dots li button::before {
    font-size: 8px;
    color: ${ds.brand('text')};
    opacity: 0.7;
}

.slick-slider .slick-list {
  margin-bottom: 25px;
}

.slick-slider .slick-dots li.slick-active button::before {
    color: ${ds.brand('product')};
    opacity: 1;
}

.slick-slider .slick-list .slick-track {
  display: flex;
}

.slick-track div {
  outline: none;
}
`;



// WEBPACK FOOTER //
// ./src/common/global-styles.js